module.exports = __webpack_public_path__ + "static/media/style-persona-1.55370856.png";